module.exports = __webpack_public_path__ + "img/symbol_7.bc8ffd6f.png";